import { useCallback, useEffect, useRef, useState } from 'react';

import {
  CenterControl,
  DEFAULT_ZOOM_WITH_PERMISSION,
  DEFAULT_ZOOM_WITHOUT_PERMISSION,
  FALLBACK_LOCATION,
} from './utils';

export function useGoogleMapsData() {
  const mapRef = useRef(null);
  const [currentPosition, setCurrentPosition] = useState(null);
  const [currentZoom, setCurrentZoom] = useState(
    DEFAULT_ZOOM_WITHOUT_PERMISSION,
  );
  const [myGeoLocation, setMyGeoLocation] = useState(null);

  const successCurrentLocation = position => {
    const currentPositionEntity = {
      lat: position.coords.latitude,
      lng: position.coords.longitude,
    };
    setCurrentPosition(currentPositionEntity);
    setMyGeoLocation(currentPositionEntity);
    setCurrentZoom(DEFAULT_ZOOM_WITH_PERMISSION);
  };

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(successCurrentLocation);
  }, []);

  useEffect(() => {
    if (mapRef) {
      const centerControlDiv = document.createElement('div');
      CenterControl(centerControlDiv, mapRef);
      centerControlDiv.index = 1;
      mapRef.current.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.controls[
        google.maps.ControlPosition.RIGHT_BOTTOM
      ].push(centerControlDiv);
    }
  }, [mapRef]);

  const getCenter = useCallback(() => {
    if (!mapRef || !mapRef.current) {
      return null;
    }

    return mapRef.current.getCenter();
  }, []);

  const handleMapDragEnd = useCallback(() => {
    if (!mapRef || !mapRef.current) {
      return;
    }

    const newCenter = getCenter();

    if (!newCenter) {
      return;
    }

    const newPosition = {
      lat: newCenter.lat(),
      lng: newCenter.lng(),
    };

    setCurrentPosition(newPosition);
  }, [getCenter]);

  return {
    mapRef,
    zoom: currentZoom,
    isMyPosition: !!myGeoLocation,
    myGeoLocation,
    currentPosition: currentPosition || {
      lat: FALLBACK_LOCATION.latitude,
      lng: FALLBACK_LOCATION.longitude,
    },
    handleMapDragEnd,
  };
}



// WEBPACK FOOTER //
// ./src/components/GoogleMaps/useGoogleMapsData.js